module.exports = __webpack_public_path__ + "img/fa.cbf54459.png";